import { render, staticRenderFns } from "./native-live.vue?vue&type=template&id=9a9fb364&scoped=true"
import script from "./native-live.vue?vue&type=script&lang=js"
export * from "./native-live.vue?vue&type=script&lang=js"
import style0 from "./native-live.vue?vue&type=style&index=0&id=9a9fb364&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a9fb364",
  null
  
)

export default component.exports